<template>
  <div id="other_associations_outer" class="vue_body_min_height">
    <img v-if="currentBanner != null" :src="currentBanner.url" style="width: 100vw;height: auto;margin-top: -2px;">
    <div class="container" >
      <div id="osscia_menu">
        <div v-for="(item, index) in tabList" style="padding: 0 15px;">
          <a href="javascript:void(0);" :class="[tabIndex == index ? 'active' : '']" @click="tabItemClicked(index)">{{item.name}}</a>
        </div>
      </div>
      <div id="osscia_main_body" >
        <div id="osscia_main_top" v-if="tabIndex != 0" v-html="tabList[tabIndex].desc"></div>

        <div id="osscia_main_content">
          <associations-news-list v-bind:tagId="tabList[tabIndex].id" v-bind:tagName="tabList[tabIndex].name" />
        </div>

      </div>
    </div>



  </div>
</template>

<script>

import AssociationsNewsList from "../components/other-associations/AssociationsNewsList";
export default {
  name: "OtherAssociationsPage",
  components: {
    AssociationsNewsList,
  },
  data() {
    return {
      title: '其他篮协',
      tabList: [
        {
          name: '各区篮协',
          id: 0,
          desc: '各区篮协精选新闻',
        },
      ],
      tabIndex: 0,
    }
  },
  computed: {

    banners() {
      return this.$store.state.banners;
    },
    currentBanner() {
      if (this.banners == null) {
        return null;
      }
      let item = this.banners.find(function (item) {
        return  item.name == 'associations';
      });

      if (item == undefined) {
        return null;
      }
      return item;
    },

    currentPath() {
      // let tabList = this.$store.state.tabList;
      // console.log(tabList);
      return this.$store.state.tabList[5].src;
    },
    apiManager() {
      return this.$store.state.http;
    },
  },
  mounted() {
    this.loadTabsData();
    let shareObj = this.$store.state.http.defaultShareObj;
    shareObj.title = '各区篮协'
    shareObj.link = location.href;
    this.configShareWx(encodeURIComponent(location.href), shareObj);
  },
  methods: {
    loadTabsData() {
      let _this = this;
      this.apiManager.ajax.vmAreas(function (data){
        let code = data.code;
        if (code == 0) {
          let list = data.data;
          if (list != null && list.length > 0) {
            _this.tabList = _this.tabList.concat(list);
          }
          return;
        }

        _this.$toast('请求失败！');

      }, function (data) {
        _this.$toast('请求失败，请重试！');
      });
    },
    tabItemClicked(index) {
      this.tabIndex = index;
    }
  }
}
</script>

<style scoped>

  #other_associations_outer {

  }

  #osscia_menu {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
  }

  #osscia_menu a {
    color: #333;
    font-size: 1.5rem;
    text-decoration: none;
    padding: 10px 0;
    display: inline-block;
  }

  #osscia_menu a.active {
    color: #fc1a34;
    border-bottom: solid 4px #fc1a34;
  }

  #osscia_menu a:hover {
    color: #fc1a34;
  }

  #osscia_main_body {
    padding: 0;
    margin-top: 4vh;
    margin-bottom: 60px;
  }

  #osscia_main_content, #osscia_main_top {
    width: 100%;
    box-shadow: 0 0 15px rgba(255,0,0, 0.15);
  }

  #osscia_main_top {
    padding: 30px 30px;
  }

  #osscia_main_content {
    margin-top: 20px;
    padding: 15px;
    padding-top: 0;
  }


</style>



// WEBPACK FOOTER //
// src/pages/OtherAssociationsPage.vue